import { useCallback } from 'react'

import type { SurveyFilters } from 'app/common/types/surveys'
import { PlainInputDate } from 'app/common/ui-next/plain-input-date'
import SimpleDate from 'app/common/classes/simple-date'

import styles from './PeriodFilter.module.scss'

export const dateFormat = 'DD.MM.YYYY'

const getDateAsString = (value: SurveyFilters['from'] | SurveyFilters['to']) => {
  if (!value) return ''
  if (typeof value === 'string') return value
  return value.getString(dateFormat) || ''
}

const toSimpleDate = (value: string): SurveyFilters['from'] => {
  if (!value) return null
  return new SimpleDate(value, dateFormat)
}

type Props = {
  value: SurveyFilters
  onChange: (value: SurveyFilters) => void
  horizontal?: boolean
  disabled?: boolean
}

export const PeriodFilter = ({
  value,
  onChange,
  horizontal,
  disabled,
}: Props) => {
  const fromDate = getDateAsString(value.from)
  const toDate = getDateAsString(value.to)

  const handleDateFromChange = useCallback((from: string) => {
    onChange({
      ...value,
      from: toSimpleDate(from),
    })
  }, [onChange, value])

  const handleDateToChange = useCallback((to: string) => {
    onChange({
      ...value,
      to: toSimpleDate(to),
    })
  }, [onChange, value])

  return (
    <div className={horizontal ? styles.horizontal : styles.vertical}>
      <label className={styles.field}>
        <span>{'С:'}</span>
        <PlainInputDate
          value={fromDate}
          dateFormat={dateFormat}
          onDateChange={handleDateFromChange}
          calendarCloseOnClick
          disabled={disabled}
        />
      </label>
      <label className={styles.field}>
        <span>{'По:'}</span>
        <PlainInputDate
          value={toDate}
          dateFormat={dateFormat}
          onDateChange={handleDateToChange}
          calendarCloseOnClick
          disabled={disabled}
        />
      </label>
    </div>
  )
}
